import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { AlertService } from './alert.service';
import { GlobalService } from './global.service';
import { AppUrl } from '../constants/app-url';
import { UploadService } from './upload.service';

@Injectable({
  providedIn: 'root'
})
export class FileService extends BaseService {
  constructor(public http: HttpClient,
              public alertService: AlertService,
              public globalService: GlobalService,
              public fileUploadService: UploadService) {
    super(http, alertService, globalService);
  }

  fileUpload(params: any, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
  }

  singleFileUpload(data: {}, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.SINGLE_FILE_UPLOAD(), data, event);
  }

  fileMultipleUpload(data: {}, event: any): Observable<any> {
    return this.fileUploadService.fileUpload(AppUrl.MULTIPLE_FILE_UPLOAD(), data, event);
  }

  updateProfileLogo(data: {}): Observable<any> {
    return this.fileUploadService.postRequest(AppUrl.SINGLE_FILE_UPLOAD(), data);
  }

  updateProfileImage(data: {}): Observable<any> {
    return this.fileUploadService.postRequest(AppUrl.SINGLE_FILE_UPLOAD(), data);
  }

}
